
















import { Component, Vue } from 'vue-property-decorator';

import DevHeaderRoutes from './dev-header-routes.vue';
import DevHeaderUser from './dev-header-user.vue';
import DevHeaderTime from './dev-header-time.vue';

@Component({
  components: {
      'dev-header-routes': DevHeaderRoutes,
      'dev-header-user': DevHeaderUser,
      'dev-header-time': DevHeaderTime,
  },
})
export default class DevHeader extends Vue {
  
  public isTest = 0;
  public interval: any = null;

  public mounted(){
    this.interval = setInterval(() => {
      if(!(this.isTest === 0)) {
        this.$store.dispatch('setTime', { hour : new Date().getHours() })
      }
    }, 5* 60 * 1000)
  }

  public onTestModeChange($event: any){
    if(!(this.isTest === 0)) {
        this.$store.dispatch('setTime', { hour : new Date().getHours() })
        this.$store.dispatch('setTime', { date : new Date() })
    }
    this.$store.dispatch('fetchUsers')
  }

  get StoreUser(): any {
    return this.$store.state.user;
  } 
  get StoreDate(): any {
    return this.$store.state.time.date;
  }   
  get StoreHour(): any {
    return this.$store.state.time.hour;
  }   
  get StorePark(): any {
    return this.$store.state.park;
  }   

}
